import { render } from "./footer.vue?vue&type=template&id=6b186ea4"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=6b186ea4&lang=css"

import exportComponent from "/home/smallred/20250930/inrunonline-website-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__